import React from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { mockBlogPosts } from '../data/mockBlog';
import SafeIcon from '../components/common/SafeIcon';
import ArticleLayout from '../components/blog/ArticleLayout';
import LeaderStoryLayout from '../components/blog/LeaderStoryLayout';

export default function BlogPostPage() {
  const { id } = useParams();
  const post = mockBlogPosts.find(p => p.id === id);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="min-h-screen bg-[var(--bg-base)]">
      {/* Mini Breadcrumb back to blog */}
      <div className="max-w-7xl mx-auto px-6 py-6">
        <Link 
          to="/blog" 
          className="inline-flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-[var(--text-secondary)] hover:text-[var(--text-main)] transition-colors"
        >
          <SafeIcon name="ArrowLeft" className="w-4 h-4" />
          Volver al Blog
        </Link>
      </div>

      {post.type === 'leader' ? (
        <LeaderStoryLayout post={post} />
      ) : (
        <ArticleLayout post={post} />
      )}
    </div>
  );
}